import React from 'react';

import { Banner, Text } from '@betterment/samba-react';

const AccountAccessBannerApp: React.FC = () => {
  return (
    <Banner variant="info" css={{ mt: '20' }}>
      <Banner.Content>
        <Text as="p">
          No longer have access to your email? Call our customer support team at 718-400-6898 to update your email
          address so you can access your account.
        </Text>
      </Banner.Content>
    </Banner>
  );
};

export default AccountAccessBannerApp;
